var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SearchField from "../../Form/SearchField";
import CheckboxField from "../../Form/CheckboxField";
import TextField from "../../Form/TextField";
import AcademicCalendarService from "../../../Services/AcademicCalendar.service";
import { AcademicCalendarMultiSearch } from "../AcademicCalendar/AcademicCalendarSearch";
export const SSE_FORM_INTENDED_START_TERM_QUESTION_GET_CRITERIA = (formState) => {
    return formState;
};
export const SSE_FORM_INTENDED_START_TERM_QUESTION_GET_FORM_STATE = (formField) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const getIfArrayHasItems = (arr, service) => {
        if (arr === null || arr === void 0 ? void 0 : arr.length) {
            return service(arr);
        }
        return Promise.resolve([]);
    };
    const [academicCalendars] = yield Promise.all([
        getIfArrayHasItems((_a = formField.criteria) === null || _a === void 0 ? void 0 : _a.academicCalendarIds, (ids) => AcademicCalendarService.findAllById(ids)),
    ]);
    return Object.assign(Object.assign({}, formField), { criteria: Object.assign(Object.assign({}, formField.criteria), { academicCalendars }) });
});
const SSEFormIntendedStartDateQuestionForm = ({ makeName, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { maxLength: 60, name: makeName("fieldLabel"), label: "Question Label" }), _jsx(CheckboxField, { label: "Required", name: makeName("required") }), _jsx(CheckboxField, { label: "Only allow prospects to select one term", title: "Only allow prospects to select one term", name: makeName("criteria.limitSelectFieldToOne"), helpText: "Checking this box will allow prospects to select only one term from the form. Leaving this box unchecked will allow up to 5 terms to be selected." }), _jsx(SearchField, { label: "Intended Start Terms", name: makeName("criteria.academicCalendars"), as: (provided) => (_jsx(AcademicCalendarMultiSearch, Object.assign({ currentTermsOnly: true }, provided))), helpText: "Only selected terms on this field will be displayed on the form. By leaving this field empty, all current active terms in the system will be displayed." })] }));
};
export const IntendedStartDateFormComponent = {
    form: SSEFormIntendedStartDateQuestionForm,
    getCriteria: SSE_FORM_INTENDED_START_TERM_QUESTION_GET_CRITERIA,
    getFormState: SSE_FORM_INTENDED_START_TERM_QUESTION_GET_FORM_STATE,
};
